import { useOrganizationContext } from '@/contexts/organization-context';
import { useCurrentUser, useTenants } from '@/lib/auth-service';
import { useEffect, useState } from 'react';

export function useLoadingTabs() {
  const { organizationId } = useOrganizationContext();
  const { user, isLoading: isUserLoading } = useCurrentUser();
  const { tenants } = useTenants();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isUserLoading && user?.id && tenants?.length && organizationId) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [user?.id, tenants?.length, organizationId, isUserLoading]);

  return {
    loadingTabs: loading,
  };
}
